// NOTE TO MAINTAINER:
// Done this way to allow local dev builds to not fail if messages are not built.

// Normally this rule is great, but we're doing somthing unconventional.
// eslint-disable-next-line import/no-mutable-exports
let Messages;

try {
    Messages = require('../../../../locale/en-min.json');
} catch {
    try {
        Messages = require('../../../../locale/en.json');
    } catch {
        // we'll handle in the outer scope
    }

    if (!Messages && process.env.NODE_ENV === 'production') {
        throw new Error('Unable to load english messages');
    }

    Messages = {};
}

export default Messages;
